import React from 'react'
import BaseTable from './BaseTable'

type BodyPropsType = {
  children: React.ReactNode
  backgroundColor: string
  contentBackgroundColor: string
  maxWidth: number | '100%'
}

function Body({ backgroundColor, contentBackgroundColor, children, maxWidth }: BodyPropsType) {
  //style section to make gmail app ignore the dark mode and display actual background and content colors
  return (
    <>
      <style>
        {`
  #body-table {
    background-color: ${backgroundColor} !important;
  }
  #body-mobile {
    background-color: ${contentBackgroundColor} !important;
  }
      `}
      </style>
      <BaseTable id="body-table" backgroundColor={backgroundColor}>
        <BaseTable
          width={maxWidth}
          backgroundColor={contentBackgroundColor}
          className="mobile"
          id="body-mobile"
        >
          {children}
        </BaseTable>
      </BaseTable>
    </>
  )
}

export default Body
